module.exports = __webpack_public_path__ + "media/components/country-flag/static/ae-420606fbbea15b08b2c64fc343f1f2e0.svg";